module.exports = __webpack_public_path__ + "static/img/slaPurpose2.3ce91c2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slaPurpose2.png
// module id = wTfB
// module chunks = 2